var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuPlan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 238.259,
    height: 150,
    viewBox: "0 0 238.259 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e6e6e6;}.b{fill:#ec008c;}.c{fill:#f8d7d7;}.d{fill:#2f2e41;}.e{fill:#fbae47;}.f{fill:#fff;}.g{fill:#3f3d56;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-837.947 -252.13)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M308.161,265.087a82.884,82.884,0,0,0-5.8-72.872l-132.312,18.32,126.8-26.426c-53.439-66.639-157.45-22.437-147.424,61.7Z",
    transform: "translate(713.168 100.344)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 168.567,
    height: 52.49,
    transform: "translate(858.597 338.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M176.884,200.887c1.512,1.174,2.064,1.554,2.386,1.505,15.605,4.543,1.926,9.87-5.657.831Z",
    transform: "translate(728.726 131.058)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M143.947,230.75v10.669l7.681-.427L149.5,229.9Z",
    transform: "translate(710.169 149.204)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M173.156,230.75v10.669l-7.682-.427,2.134-11.1Z",
    transform: "translate(723.635 149.204)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M166.849,196.719l11.522-.426c26.581,27.865,16.528,21.509,15.79,59.745l-14.082-4.267,2.986-26.459s.788-.527.135-.538c-4.088,1.4-7.073-15.992-15.924-13.971-10.073-.483-11.714,14.461-15.79,14.51l2.988,26.459-14.084,4.267c-1.577-42.017-9.3-32.525,15.79-59.745Z",
    transform: "translate(706.471 128.184)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M152.3,235.726s-1.707-3.415-3.841-1.708-7.255,6.829-7.255,6.829-12.375,5.548-4.695,8.962,14.084-4.695,14.084-4.695c7.316-1.525,11.536-2.5,7.656-10.483C156.05,235.583,152.933,236.687,152.3,235.726Z",
    transform: "translate(703.947 151.483)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M171.744,235.726s1.707-3.415,3.84-1.708,7.255,6.829,7.255,6.829,12.377,5.548,4.695,8.962-14.082-4.695-14.082-4.695c-7.317-1.525-11.536-2.5-7.656-10.483C168,235.583,171.113,236.687,171.744,235.726Z",
    transform: "translate(722.914 151.483)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M168.761,169.822c-.634,10.624-15.132,9.688-15.363,0C154.034,159.2,168.532,160.133,168.761,169.822Z",
    transform: "translate(716.081 106.858)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M156.024,170.795c3.732,11.283-5.081,5.14,7.255,14.084l4.695-9.389s-3.415-1.281-2.988-5.975Z",
    transform: "translate(717.723 111.433)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M184.813,175.357l-12.721-2.9c.358,7.669-7.827,6.127-9.256,2.268l-12.162,7.037c5.1,19.012,3.81,19.8-2.988,32.007-2.594,2.368,1.286,3.727,4.664,2.43,2.576-1.59,3.885-3,6.645-2.643,13.045,2.716,23.905,3.357,25.623,2.3C185.234,214.968,184.6,175.51,184.813,175.357Z",
    transform: "translate(711.978 113.272)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M168.1,175.163a16.78,16.78,0,0,0,2.625-1.034c6.395-.107,10.688,42.912,11.031,44.136l-4.267,2.986-6.829-17.5Z",
    transform: "translate(725.277 114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M149.723,205.809c.218,1.611.59,19.7,7.068,11.249.85-6.164-2.04-8-2.8-12.1Z",
    transform: "translate(713.782 133.603)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M153.055,178.457l-1.307-.725c-3.506-.115-2.4,9.165-3.885,15.959-1.211,7.916-.866,16.647.556,28.317.124,4.283,7.794,1.585,8.9,1.258,0,0-2.56-17.5-1.279-20.485S153.055,178.457,153.055,178.457Z",
    transform: "translate(712.157 116.573)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M168.942,163.959a9.153,9.153,0,0,0-5.208-3.981l-1.593,1.273.619-1.486a8.631,8.631,0,0,0-1.574-.091l-1.432,1.843.593-1.78c-6.148.66-9.786,7.718-6.593,12.656.491-1.512,1.089-2.932,1.582-4.446a4.44,4.44,0,0,0,1.166.007l.6-1.4.167,1.339c1.856-.163,4.61-.517,6.37-.844l-.172-1.026,1.024.853c.54-.125.86-.237.834-.323,1.309,2.11,2.606,3.458,3.914,5.569C169.737,169.149,170.613,166.673,168.942,163.959Z",
    transform: "translate(715.565 105.275)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 37.228,
    height: 17.659,
    transform: "translate(979.847 344.678)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 23.148,
    height: 2.117,
    transform: "translate(986.887 348.377)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 23.148,
    height: 2.117,
    transform: "translate(986.887 352.448)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 23.148,
    height: 2.117,
    transform: "translate(986.887 356.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M203.215,212.915l-1.211-2.1-1.211-2.1-1.211,2.1-1.211,2.1h1.3v6.074h2.241v-6.074Z",
    transform: "translate(744.213 135.958)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M255.665,225.618a9.9,9.9,0,0,1,1.946.192,10.018,10.018,0,0,1,1.871.567,9.987,9.987,0,0,1,4.475,3.672,10.029,10.029,0,0,1,.92,1.725,9.764,9.764,0,0,1,.567,1.869,9.978,9.978,0,0,1-.567,5.763,9.979,9.979,0,0,1-5.4,5.4,9.974,9.974,0,0,1-9.357-.922,9.948,9.948,0,0,1-2.75-2.75,9.915,9.915,0,0,1-.922-1.723,9.969,9.969,0,0,1,0-7.632,9.948,9.948,0,0,1,2.162-3.235,10.034,10.034,0,0,1,1.51-1.24,9.98,9.98,0,0,1,5.54-1.681Z",
    transform: "translate(773.815 146.528)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M254.645,229.034a4.422,4.422,0,1,1-1.692.336A4.376,4.376,0,0,1,254.645,229.034Z",
    transform: "translate(776.649 148.664)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M252.821,236.039l21.755,9.065-.68,2.153-12.521-1.416-21.189-9.4,11.784,1.36Z",
    transform: "translate(770.37 153.046)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M267.4,282.76,294.453,194l6.588-11.7.024-.112a6.362,6.362,0,0,0-.686-4.321,3.881,3.881,0,0,0-2.62-1.65c-3.636-.683-11.772-1.018-12.115-1.032l-.065,0-.065.008c-.223.031-5.421.79-6.6,5.33l-5.657,10.294-.023.073L247.631,275.08l1.409.429,25.584-84.115,5.676-10.329.023-.1c.831-3.417,4.805-4.215,5.333-4.308.831.036,8.477.377,11.831,1.006a2.42,2.42,0,0,1,1.666,1.019,4.782,4.782,0,0,1,.486,3.1l-6.549,11.629-.024.076-27.08,88.834Z",
    transform: "translate(775.026 114.981)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 1.473,
    height: 19.857,
    transform: "translate(1046.118 315.762) rotate(-79.763)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 1.473,
    height: 19.802,
    transform: "translate(1042.433 327.811) rotate(-78.466)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 1.473,
    height: 19.702,
    transform: "matrix(0.275, -0.961, 0.961, 0.275, 1035.826, 349.342)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M271.725,244.333l.537-1.372-18.386-7.2-.9-9.776,17.161,6.41,5.559,8.044,1.212-.837-5.823-8.425-19.791-7.392,1.2,13.017Z",
    transform: "translate(777.316 145.381)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M271.628,231.473a9.973,9.973,0,0,1,9.212,13.788,10,10,0,0,1-2.162,3.235,9.91,9.91,0,0,1-3.235,2.16,9.9,9.9,0,0,1-1.871.569,10.039,10.039,0,0,1-3.89,0,9.9,9.9,0,0,1-1.871-.569,9.957,9.957,0,0,1-5.4-5.4,9.78,9.78,0,0,1-.567-1.871,9.959,9.959,0,0,1,0-3.89,9.779,9.779,0,0,1,.567-1.871,9.959,9.959,0,0,1,3.672-4.475,9.915,9.915,0,0,1,1.723-.922,9.983,9.983,0,0,1,3.817-.759Z",
    transform: "translate(783.8 150.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M271.095,235.168a4.422,4.422,0,1,1-1.691.336A4.376,4.376,0,0,1,271.095,235.168Z",
    transform: "translate(786.939 152.501)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuPlan);
export default __webpack_public_path__ + "static/media/menu-plan.22f38c207f59c39198adaa307aa6f6f6.svg";
export { ForwardRef as ReactComponent };